import type { ReactNode } from 'react';
import { Link } from 'react-router-dom';
import { Icon } from './Icon';
import styles from './page.module.css';

export function PageHeader({
  title,
  subtitle,
  actions,
  back,
}: {
  title: string;
  subtitle?: string | null;
  actions?: ReactNode;
  back?: { to: string; label: string };
}) {
  return (
    <header className={styles.header}>
      {back && (
        <Link to={back.to} className={styles.back}>
          <Icon name="chevronLeft" size={16} />
          {back.label}
        </Link>
      )}
      <div className={styles.headerRow}>
        <h1 className={styles.title}>{title}</h1>
        {actions && <div className={styles.actions}>{actions}</div>}
      </div>
      {subtitle && <p className={styles.subtitle}>{subtitle}</p>}
    </header>
  );
}

export function Section({
  title,
  aside,
  children,
}: {
  title: string;
  aside?: ReactNode;
  children: ReactNode;
}) {
  return (
    <section className={styles.section}>
      <div className={styles.sectionHead}>
        <h2 className={styles.sectionTitle}>{title}</h2>
        {aside && <div className={styles.sectionAside}>{aside}</div>}
      </div>
      {children}
    </section>
  );
}

export function Centred({ children }: { children: ReactNode }) {
  return <div className={styles.centred}>{children}</div>;
}

export function Loading({ label }: { label: string }) {
  return (
    <Centred>
      <div className={styles.loadingRow}>
        <span className={styles.spinner} aria-hidden="true" />
        <span>{label}</span>
      </div>
    </Centred>
  );
}
